import axios from 'axios';
import { BASEURL, COOKIE_TYPES } from '../config';
import { message } from 'antd';

// Create axios instance
const api = axios.create({
  baseURL: BASEURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(COOKIE_TYPES.MCHASHID);
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      message.error('Network error. Please check your connection.');
      return Promise.reject(error);
    }

    const { status } = error.response;
    
    switch (status) {
      case 401:
        message.error('Your authorization token is invalid or expired');
        localStorage.removeItem(COOKIE_TYPES.MCHASHID);
        window.location.href = '/login';
        break;
      case 403:
        message.error('Your authorization token is invalid or expired');
        localStorage.removeItem(COOKIE_TYPES.MCHASHID);
        window.location.href = '/login';
        break;
      case 500:
        message.error('Server error. Please try again later.');
        break;
      default:
        if (error.response.data?.message) {
          message.error(error.response.data.message);
        }
    }
    
    return Promise.reject(error.response);
  }
);

export default api;
